<template>
  <Layout>
    <banner/>
    <!-- <division :img="require('@/assets/images/gateway/icon-lp.png')" text="找楼盘·委托找房"/>
    <building-info/> -->
    <!-- <div class="cooperation">
      <division :img="require('@/assets/images/gateway/icon-hz.png')" text="合作伙伴" bgColor="#E4EEFE"/>
      <div class="cooperation-list">
        <div v-for="(item, index) in listNum" :key="`cooperation-list-row-${index}`" class="cooperation-list-row">
          <div v-for="(items, ind) in item" :key="`cooperation-list-col-${ind}`" class="cooperation-list-col">
            <img :src="items"/>
          </div>
        </div>
      </div>
    </div> -->
  </Layout>
</template>
<script>
import Banner from '../components/banner.vue'
// import Division from '../components/division.vue'
// import BuildingInfo from './buildingInfo.vue'
import Layout from '../Layout'
import SRT from '@/assets/images/gateway/partner/SRT.png'
import SFAB from '@/assets/images/gateway/partner/SFAB.png'
import SFKJ from '@/assets/images/gateway/partner/SFKJ.png'

import HQKFWY from '@/assets/images/gateway/partner/HQKFWY.png'
import HXHJ from '@/assets/images/gateway/partner/HXHJ.png'
import PABX from '@/assets/images/gateway/partner/PABX.png'
import FCWLW from '@/assets/images/gateway/partner/FCWLW.png'

import HXXX from '@/assets/images/gateway/partner/HXXX.png'
import XDSM from '@/assets/images/gateway/partner/XDSM.png'
import JJKJ from '@/assets/images/gateway/partner/JJKJ.png'
import ZLGJ from '@/assets/images/gateway/partner/ZLGJ.png'
import NYYH from '@/assets/images/gateway/partner/NYYH.png'

import SWHY from '@/assets/images/gateway/partner/SWHY.png'
import TRYY from '@/assets/images/gateway/partner/TRYY.png'
import LLJF from '@/assets/images/gateway/partner/LLJF.png'
import ZXYH from '@/assets/images/gateway/partner/ZXYH.png'
export default {
  components: {
    Banner,
    // Division,
    // BuildingInfo,
    Layout
  },
  data () {
    return {
      listNum: [[SRT, SFAB, SFKJ], [HQKFWY, HXHJ, PABX, FCWLW], [HXXX, XDSM, JJKJ, ZLGJ, NYYH], [SWHY, TRYY, LLJF, ZXYH]]
    }
  }
}
</script>

<style lang="scss" scoped>
.cooperation {
  background: #E4EEFE;
  .cooperation-list {
    padding: 0.2rem 10%;
    .cooperation-list-row {
      display: flex;
      justify-content: center;
      margin: 0.2rem 0;
      .cooperation-list-col {
        margin: 0 0.2rem;
        img {
          width: 2.5rem;
        }
      }
    }
  }
}
</style>